// extracted by mini-css-extract-plugin
export var table = "_v1-0";